<template>
  <div class="account-modal">
    <!-- <Modal v-model="accountModalState" class="accountModalBox" @on-cancel="cancelHandle" :mask-closable="false" class-name="vertical-center-modal">
      <span slot="header"></span>
      <div class="modal-content">
        <ContentZH :isShow="accountModalState"></ContentZH>
      </div>
      <div slot="footer"></div>
    </Modal> -->
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import ContentZH from './zh-CN/Content'

export default {
  name: 'AccountModal',
  components: { ContentZH },
  computed: {
    accountModalState: {
      get () {
        return this.isShowAccountModal()
      },
      set (v) {
        this.setAccountModalState(v)
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$root.$on('closeAccountModalEvent', () => {
        this.accountModalState = false
      })
    })
  },
  methods: {
    cancelHandle (event) {
      this.$root.$emit('clearFormCloseModal', event)
    },
    ...mapState('account', {
      isShowAccountModal: state => state.isShowModal
    }),
    ...mapMutations({
      setAccountModalState: 'account/setModalState'
    })
  }
}
</script>
<style>
  @media print,screen and (min-width:1366px) {
    .accountModalBox .vertical-center-modal,
    .accountModalBox .ivu-modal{
      width: 380px !important;
    }
  }
  @media print,screen and (max-width:1365px) {
    .accountModalBox .vertical-center-modal,
    .accountModalBox .ivu-modal{
      width: 320px !important;
    }
    .ie .accountModalBox .ivu-select .ivu-select-input{
      top: -2.2px !important;
    }
  }
  .accountModalBox .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    margin-top: -20px;
  }
  .accountModalBox .vertical-center-modal .ivu-modal{
    top: 0;
  }
  .accountModalBox .ivu-modal-content{
    border: 0.5px solid #D8D8D8;
    border-radius: 3px;
    padding: 0 5px;
  }
  .accountModalBox .ivu-modal-header,
  .accountModalBox .ivu-modal-footer{
    display: none;
  }
  .accountModalBox .header{
    padding: 0px 16px 12px 2px;
    border-bottom: 0.5px solid #D8D8D8;
    font-size: 15px;
    color: #333;
    margin-bottom: 15px;
  }
  .accountModalBox .footer{
    margin-top: 20px;
    margin-bottom: 8px;
  }
  .accountModalBox .ivu-modal-close{
    top: 16px;
    right: 22px;
  }
  .accountModalBox .ivu-modal-close:hover{
    text-decoration: none;
    box-shadow: none;
  }
  .accountModalBox .ivu-select .ivu-select-dropdown-list{
    padding: 5px 0;
    color: #333;
  }
  .accountModalBox .ivu-select .ivu-select-item-selected.ivu-select-item-focus{
    background-color: #f8f8f8;
    color: #333;
  }
  .accountModalBox .ivu-select .ivu-select-not-found{
    font-size: 13px;
    padding: 12px 0;
  }
  .accountModalBox .ivu-select .ivu-icon{
    color: #DBDBDB;
  }
  .accountModalBox .ivu-select .ivu-select-input,
  .accountModalBox .ivu-input{
    border: 0.5px solid #DBDBDB;
    padding-left: 25px;
    border-radius: 2px;
    font-size: 14px;
  }
  .accountModalBox .ivu-select .ivu-select-input{
    border: 0 none;
    position: relative;
    top: -1px;
  }
  .accountModalBox .form-icon{
    background: url("~@/assets/images/icons/account/uid.png") 0 0 no-repeat transparent;
    width: 11px;
    height: 10px;
    background-size: auto 10px;
    z-index: 1;
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
    margin-top: 0.5px;
  }
  .accountModalBox .ivu-radio{
    margin-right: 3px;
  }
  .accountModalBox .ivu-radio-wrapper,
  .accountModalBox .ivu-checkbox-wrapper{
    font-size: 1.3rem;
  }
  .accountModalBox .ivu-checkbox{
    padding-right: 3px;
    position: relative;
    top:-1px;
  }
  .accountModalBox .ivu-checkbox .ivu-checkbox-inner{
    width: 12px;
    height: 12px;
  }
  .accountModalBox .ivu-checkbox.ivu-checkbox-checked .ivu-checkbox-inner:after{
    left: 3.5px;
  }
  .accountModalBox .ivu-form-item{
    margin-bottom: 15px;
  }
  .accountModalBox .ivu-form-item-error{
    margin-bottom: 30px;
  }
  .accountModalBox .ivu-form-item.ivu-form-item-error:last-child{
    margin-bottom: 35px;
  }
  .accountModalBox .ivu-form-item-error-tip{
    font-size: 12px;
    padding-top: 9px;
    padding-bottom: 10px;
  }
  .accountModalBox .ivu-input:focus{
    border-color: #1F8AFD;
  }
  .accountModalBox .ivu-modal-close .ivu-icon-ios-close-empty{
    width: 11px;
    height: 11px;
    background: url("~@/assets/images/icons/close.png") 0 0 no-repeat transparent;
    background-size: 11px;
  }
  .accountModalBox .ivu-modal-close .ivu-icon-ios-close-empty:before{
    content: none;
  }
  .accountModalBox .ivu-btn{
    padding: 8px 20px;
    border-radius: 2px;
  }
  .accountModalBox .ivu-btn-primary{
    /* background-image: linear-gradient(-90deg, #0F7EF3 0%, #27BEFE 100%); */
    background: #0774b5;
    border-radius: 3px;
    width: 100%;
    font-size: 13px;
    border: 0 none;
  }
  .accountModalBox .ivu-btn-primary[disabled]{
    background-image: none;
    border: 1px solid #dddee1;
  }
  .accountModalBox .ivu-icon{
    cursor: pointer;
  }
  .accountModalBox .ivu-select .ivu-select-input::-webkit-input-placeholder,
  .accountModalBox .ivu-input::-webkit-input-placeholder{
    font-size: 12px;
    position: relative;
    top: -1px
  }
  .accountModalBox .ivu-select .ivu-select-input:-moz-placeholder,
  .accountModalBox .ivu-input:-moz-placeholder{
    font-size: 12px;
    position: relative;
    top: -1px
  }
  .accountModalBox .ivu-select .ivu-select-input::-moz-placeholder,
  .accountModalBox .ivu-input::-moz-placeholder{
    font-size: 12px;
    position: relative;
    top: -1px
  }
  .accountModalBox .ivu-select .ivu-select-input:-ms-input-placeholder,
  .accountModalBox .ivu-input:-ms-input-placeholder{
    font-size: 12px;
    position: relative;
    top: -1px
  }
</style>



// WEBPACK FOOTER //
// src/components/account/Modal.vue